export default "__VITE_ASSET__CNGSFF_v__"